





























































































import { Either, Left, Right } from 'fp-ts/lib/Either'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import { convertLongIdToDisplayId } from '@/models/api/id'
import { ContextFactory } from '@/models/order-history/status/context/context'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'

import { AddressFormState } from '@spa/components/organisms/profile/addressFormState'
import { NameFormState } from '@spa/components/organisms/profile/nameFormState'
import { PhoneticNameFormState } from '@spa/components/organisms/profile/phoneticNameFormState'
import ReorderContactProfile from '@spa/components/organisms/profile/ReorderContactProfile.vue'
import ReorderUserProfile from '@spa/components/organisms/profile/ReorderUserProfile.vue'
import { AddressFieldsEnabledState } from '@spa/components/pages/mypage/edit/contact/interaction'
import { toQuery } from '@spa/components/pages/order/scope-transpiler'

import { HlAppModeMixin } from '@spa/mixins/hl-app-mode'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'

import { Order, PaymentPoint } from '@spa/store/modules/orderHistory/types'

import { log } from '@/log'
import { ApiContact, ContactService } from '@spa/services/api/contact'
import { PurchaseService } from '@spa/services/api/purchase'
import { SellerSalesOrder } from '@spa/services/api/sellerSalesOrder'
import { convertToRegionId, convertToRegionName } from '@spa/services/region'
import { Contact } from '@spa/store/modules/contact/types'
import { User } from '@spa/store/modules/user/types'
import { UserValidator } from '@spa/validation/user'

import Fade from '@spa/components/atoms/transition/Fade.vue'

import {
  ModalState,
  NoError,
} from './model/modal-state'

import { adCodeStore } from '@/util/adcode/store'
import { createTransferAuxDataOnReorder } from './model/aux-data/create-transfer-aux-data-on-reorder'
import { foldValidationResults } from './model/specification/profile'
import {
  CannotReorderForCanceledSpecification,
  OrderMustExistSpecification,
  OrderSpecificationList,
} from './model/specification/profile/order-specification'
import {
  OrderStatusSpecificationList,
  ReorderAfterRegistrationSpecification,
} from './model/specification/profile/order-status-specification'

import {
  LoginSpecification,
  UserMustExistSpecification,
  UserSpecificationList,
} from './model/specification/profile/user-specification'

Component.registerHooks([
  'beforeRouteEnter',
])

@Component({
  components: {
    ReorderContactProfile,
    ReorderUserProfile,
    SpaErrorDialog,
    Fade,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class ReorderProfile extends Mixins<PluginMixin & HlAppModeMixin>(PluginMixin, HlAppModeMixin) {

  pageStatus: Status = Status.Pending

  submitStatus: Status = Status.Pending

  modalState: ModalState = new NoError()

  validator: UserValidator = new UserValidator()

  userFirstName: string = ''

  userLastName: string = ''

  userPhoneticFirstName: string = ''

  userPhoneticLastName: string = ''

  userTel: string = ''

  userZipcode: string = ''

  userPrefectureCode: string | undefined = ''

  userCity: string = ''

  userTown: string = ''

  userAddressFieldsEnabledState: AddressFieldsEnabledState =
    AddressFieldsEnabledState.init({})

  contactFirstName: string = ''

  contactLastName: string = ''

  contactTel: string = ''

  contactZipcode: string = ''

  contactPrefectureCode: string | undefined = ''

  contactCity: string = ''

  contactTown: string = ''

  contactAddressFieldsEnabledState: AddressFieldsEnabledState

  contactSearchAddressEnabled: boolean = true

  sellerSalesOrder = new SellerSalesOrder()

  contactService = new ContactService()
  purchaseService = new PurchaseService()

  get isLoading(): boolean {
    return this.pageStatus === Status.Loading || this.submitStatus === Status.Loading
  }

  get isPageCompleted(): boolean {
    return this.pageStatus === Status.Completed
  }

  get errorOnLoadUser() {
    return _.get(this.$store.state.user, 'error.load')
  }

  get errorOnUpdateUser() {
    return _.get(this.$store.state.user, 'error.update')
  }

  get orderId(): string {
    const { id } = this.$route.params

    return id
  }

  get order(): Order {
    return this.$store.state.orderHistory.item
  }

  get contactId(): string {
    return this.order.delivery.contactId
  }

  get contact(): Contact {
    return this.$store.getters['contact/get'](this.contactId)
  }

  get user(): User {
    return this.$store.state.user.user
  }

  get fillMemberInfoStatus(): boolean {
    return this.$store.getters['user/getFillMemberInfo']
  }

  get appliedPoints(): PaymentPoint | undefined {
    return this.order.payment.point
  }

  /**
   * @see https://github.com/my-color/front/issues/113#issuecomment-669776637
   */
  get paymentParam(): string {
    const param = {
      payment_type: 'np-postpay',
      ...this.appliedPoints && { point: this.appliedPoints },
    }

    return JSON.stringify(param)
  }

  get adCode(): string | null {
    return adCodeStore.read().toNullable()
  }

  get cancelUrl(): string {
    return `/mypage/order/${this.orderId}`
  }

  async created() {
    this.pageStatus = Status.Loading
    const makePageFailed = () => this.pageStatus = Status.Failed

    await this.initUser()

    const userSpecificationList = new UserSpecificationList([
      new LoginSpecification(
        () => {
          this.$router.push('/login')
          makePageFailed()
        }
      ),
      new UserMustExistSpecification(makePageFailed),
    ])

    await this.initOrder()

    const orderSpecificationList = new OrderSpecificationList([
      new OrderMustExistSpecification(makePageFailed),
      new CannotReorderForCanceledSpecification(makePageFailed),
    ])
    const orderStatusSpecificationList = new OrderStatusSpecificationList([
      new ReorderAfterRegistrationSpecification(makePageFailed),
    ])
    const orderHistoryStatusContext = ContextFactory.fromStore(this.order).create()

    this.modalState = foldValidationResults([
      userSpecificationList.validate(this.user),
      orderSpecificationList.validate(this.order),
      orderStatusSpecificationList.validate(orderHistoryStatusContext),
    ])(() => {
      this.setInitialFieldValues(this.user, this.order)
      this.pageStatus = Status.Completed
    })
  }

  async initUser(): Promise<void> {
    await this.$store.dispatch('user/get', { force: true })
  }

  async initOrder(): Promise<void> {
    await this.$store.dispatch('orderHistory/get', this.orderId)
  }

  async submit() {
    if (this.submitStatus === Status.Loading) {
      return
    }

    this.registerReorderProfileData()
  }

  async registerReorderProfileData(): Promise<void> {

    this.submitStatus = Status.Loading

    try {
      await this.validateForm()

      await this.updateUser()
      const contactId = await this.createOrUpdateContact()
      const provisionalOrderId = await this.createProvisionalOrderId()

      const createdOrderId = await this.reorder(provisionalOrderId, contactId)

      if (this.hlAppMode.isViewedInHlAppWebView) {
        this.goToHlAppOrderComplete()
      } else {
        this.$router.push(`/order/complete/${createdOrderId}?scope=${toQuery(this.order.cartScope)}`)
      }
      this.submitStatus = Status.Completed
    } catch (e) {
      this.modalState = {
        message: e.message,
        shown: true,
      }
      this.submitStatus = Status.Failed
    }
  }

  async updateUser(): Promise<void> {
    const payload = this.makeUserPayload()

    await this.$store.dispatch('user/update', payload)

    if (this.errorOnUpdateUser) {
      log.error(this.errorOnUpdateUser)

      throw new Error('ユーザ情報の更新に失敗したため、再注文できませんでした。')
    }
  }

  async createOrUpdateContact(): Promise<string> {
    try {
      if (await this.contactExist(this.contactId)) {
        await this.updateContact(this.contactId)

        return this.contactId
      }

      return await this.createContact()
    } catch (err) {
      log.error(err)

      throw new Error('住所情報の更新に失敗したため、再注文できませんでした。')
    }
  }

  async createProvisionalOrderId(): Promise<string> {
    try {
      const provisionalOrderIdResult = await this.purchaseService.createProvisionalOrderId()

      return provisionalOrderIdResult
        .map(orderId => orderId)
        .mapLeft((e) => { throw e }).value
    } catch (err) {
      log.error(err)

      throw new Error('エラーが発生したため、再注文できませんでした。')
    }
  }

  async contactExist(contactId: string): Promise<boolean> {

    const result = await this.contactService.get(contactId)

    if (result.isLeft()) {
      return false
    }

    if (!result.value.body.data) {
      return false
    }

    return true
  }

  async createContact(): Promise<string> {
    const payload = this.makeContactPayload()

    const result = await this.contactService.create(payload, { with: 'id' })

    if (result.isLeft()) {
      throw result.value
    }

    const { id: createdContactId } = result.value.body.data

    return createdContactId as string
  }

  async updateContact(id: string): Promise<void> {
    const payload = this.makeContactPayload()

    const result = await this.contactService.update(id, payload)

    if (result.isLeft()) {
      throw result.value
    }
  }

  async reorder(provisionalOrderId: string, contactId: string): Promise<string> {
    try {
      const payload = this.makeReorderPayload(provisionalOrderId, contactId)
      const result = await this.purchaseService.supercede(payload)

      if (result.isLeft()) {
        throw result.value
      }

      const { sales_order_id: createdOrderId } = result.value.body.data.salesOrders[0]

      if (this.order.isPreOrder) {
        const resultMark = await this.markAsPreOrder(createdOrderId)

        resultMark.mapLeft(e => log.error(e)) // 予約タグ付与失敗は、ユーザーに通知しない
      }

      return createdOrderId as string
    } catch (err) {
      log.error(err)

      throw new Error('エラーが発生したため、再注文できませんでした。')
    }
  }

  handleUserTelFormUpdated(val: string): void {
    this.userTel = val
  }

  handleUserNameFormUpdated(val: NameFormState): void {
    const { firstName, lastName } = val

    this.userFirstName = firstName
    this.userLastName = lastName
  }

  handleUserPhoneticNameFormUpdated(val: PhoneticNameFormState): void {
    const { phoneticFirstName, phoneticLastName } = val

    this.userPhoneticFirstName = phoneticFirstName
    this.userPhoneticLastName = phoneticLastName
  }

  handleUserAddressFormUpdated(val: AddressFormState): void {
    const { zipcode, prefectureCode, city, town } = val

    this.userZipcode = zipcode
    this.userPrefectureCode = prefectureCode
    this.userCity = city
    this.userTown = town
  }

  enableUserAddressFields(): void {
    this.userAddressFieldsEnabledState =
      this.userAddressFieldsEnabledState.searchedAddress()
  }

  handleContactTelFormUpdated(val: string): void {
    this.contactTel = val
  }

  handleContactNameFormUpdated(val: NameFormState): void {
    const { firstName, lastName } = val

    this.contactFirstName = firstName
    this.contactLastName = lastName
  }

  handleContactAddressFormUpdated(val: AddressFormState): void {
    const { zipcode, prefectureCode, city, town } = val

    this.contactZipcode = zipcode
    this.contactPrefectureCode = prefectureCode
    this.contactCity = city
    this.contactTown = town
  }

  enableContactAddressFields(): void {
    this.contactAddressFieldsEnabledState =
      this.contactAddressFieldsEnabledState.searchedAddress()
  }

  handleModalClose(): void {
    this.modalState = new NoError()
  }

  private async markAsPreOrder(salesOrderId: string): Promise<Either<Error, null>> {
    try {
      await this.sellerSalesOrder.appendTag(
        salesOrderId,
        [
          'mycolor.salesorder.preorder',
        ]
      )

      return new Right(null)
    } catch (err) {
      return new Left(err)
    }
  }

  private async validateForm(): Promise<void> {
    // To force to validate untouched fields
    this.$validator.fields.map((field) => {
      this.$validator.flag(field.name, {
        touched: true,
      })
    })

    const allFormsIsValid = await this.$validator.validateAll()
    if (allFormsIsValid) {
      return
    }

    throw new Error('入力内容が正しくありません')
  }

  private makeUserPayload(): object {
    return {
      first_name: this.userFirstName,
      last_name: this.userLastName,
      tel: this.userTel,
      phonetic_first_name: this.userPhoneticFirstName,
      phonetic_last_name: this.userPhoneticLastName,
      zipcode: this.userZipcode,
      region: this.userPrefectureCode,
      address1: this.userCity,
      address2: this.userTown,
    }
  }

  private makeContactPayload(): ApiContact {
    return {
      postal_code: this.contactZipcode,
      region_code: this.contactPrefectureCode,
      region: convertToRegionName(this.contactPrefectureCode!),
      locality: this.contactCity,
      street_address: this.contactTown,
      first_name: this.contactFirstName,
      last_name: this.contactLastName,
      tel: this.contactTel,
      display_level: 0,
      location_kind: 0,
      is_delivery: true,
    }
  }

  private makeReorderPayload(provisionalOrderId: string, contactId: string): object {
    return {
      sales_order_id: provisionalOrderId,
      supercede_sales_order_id: this.orderId,
      payment: this.paymentParam,
      delivery: this.makeDeliveryParam(contactId),
      aux_string_3: convertLongIdToDisplayId(provisionalOrderId),
      memo: this.adCode,
      attachment: JSON.stringify(this.order.attachment),
      ...createTransferAuxDataOnReorder(this.order),
    }
  }

  private makeDeliveryParam(contactId: string): string {
    const param = {
      ...{
        delivery_type: 'registered',
        id: contactId,
        delivery_method: this.order.delivery.deliveryMethod,
      },
      ...this.order.delivery.date && {
        date: this.order.delivery.date,
      },
      ...this.order.delivery.timeSlot && {
        timeSlot: this.order.delivery.timeSlot,
      },
      ...this.order.delivery.unattendedDelivery && {
        unattended_delivery: this.order.delivery.unattendedDelivery,
      },
    }

    return JSON.stringify(param)
  }

  private setInitialFieldValues(user: User, order: Order): void {
    this.setInitialUserFieldValues(user)
    this.setInitialContactFieldValues(order)
  }

  private setInitialUserFieldValues(user: User): void {
    this.userFirstName = user.first_name!
    this.userLastName = user.last_name!
    this.userPhoneticFirstName = user.phonetic_first_name!
    this.userPhoneticLastName = user.phonetic_last_name!
    this.userTel = user.tel!
    this.userZipcode = user.zipcode!
    this.userPrefectureCode = user.region!
    this.userCity = user.address1!
    this.userTown = user.address2!
    this.userAddressFieldsEnabledState = AddressFieldsEnabledState.init({
      zipcode: this.userZipcode,
      prefectureCode: this.userPrefectureCode,
      city: this.userCity,
      town: this.userTown,
    })
  }

  private setInitialContactFieldValues(order: Order): void {
    this.contactFirstName = order.delivery.contact.name.firstName
    this.contactLastName = order.delivery.contact.name.lastName
    this.contactTel = order.delivery.contact.tel
    this.contactZipcode = order.delivery.contact.address.code
    this.contactPrefectureCode = convertToRegionId(order.delivery.contact.address.region)
    this.contactCity = order.delivery.contact.address.locality
    this.contactTown = order.delivery.contact.address.street
    this.contactAddressFieldsEnabledState = AddressFieldsEnabledState.init({
      zipcode: this.contactZipcode,
      prefectureCode: this.contactPrefectureCode,
      city: this.contactCity,
      town: this.contactTown,
    })
  }
}
